// Set body padding for fixed menu
const primaryMenu = document.querySelector('#primary-menu');
const primaryMenuHeight = (primaryMenu) ? primaryMenu.offsetHeight : 0;

const menuOffset = primaryMenuHeight;

function containerPadding() {
    document.body.style.paddingTop = menuOffset + 'px';
}

// Hamburger open/close animation
function hamburgerMenu() {
    const hamburgerMenu = document.querySelectorAll('.burger');

    hamburgerMenu.forEach(function (item, index) {
        item.addEventListener('click', function () {
            item.classList.toggle('burger-active');
        });
    });
}

containerPadding();
hamburgerMenu();

// Add to cart - header button interaction
// Hook to the added_to_cart body event triggered by WooCommerce (Note: jQuery is used in WooCommerce's add-to-cart.js)
jQuery(document.body).on('added_to_cart', function (e, fragments, cart_hash, $button) {

    const delay = 400;

    // Flash function
    function flash(element, delay = 400) {

        element.classList.add('fade');

        setTimeout(function () {
            element.classList.remove('fade');
        }, delay);
    }

    // Flash cart button in header
    const headerCartBtn = document.querySelector('header .cart-button');
    flash(headerCartBtn, delay);

    // Update cart count in header
    setTimeout(function () {

        // Note: cart-count is injected through the woocommerce_add_to_cart_fragments filter in PHP
        headerCartBtn.querySelector('.cart-button-count').textContent = fragments['cart-count'];
    }, delay);
});
